module.exports = __webpack_public_path__ + "img/symbol_2.b11b97b9.png";